import { LnRouterTableColumn } from "./LnRouterTableColumn";
import * as shajs from "sha.js";

export class LnRouterTableDefinition<T> {

    constructor(
        public columns: LnRouterTableColumn<T>[],
    ) {}

    private groupBy<T>(array: T[], key: (x:T)=> any) {
        return array.reduce(function (rv, x) {
            const value = key(x);
            (rv[value] = rv[value] || []).push(x);
            return rv;
        }, {});
    };

    get groupedColumns(): Map<string, LnRouterTableColumn<T>[]> {
        const cols = this.columns;
        const grouped = this.groupBy(cols, col => col.options.headerGroup);
        const map = new Map<string, LnRouterTableColumn<T>[]>();
        for (const key of Object.keys(grouped)) {
            map.set(key, grouped[key]);
        }
        return map;
    }

    get reactTableColumns() {
        const columns = [];
        for (const group of this.groupedColumns.values()) {
            if (!group[0].options.headerGroup) {
                columns.push(...group.map(col => {
                    return col.reactTable;
                }));
            } else {
                columns.push({
                    id: group[0].key + '-header',
                    Header: group[0].headerGroupComponent,
                    columns: group.map(col => col.reactTable)
                })
            }
        }
        return columns;
    }

    get hash(): string {
        /**
         * Changes in case the table needs an update.
         */
        return new shajs.sha256().update(JSON.stringify(this.reactTableColumns)).digest("hex");
    }

    copy(): LnRouterTableDefinition<T> {
        return new LnRouterTableDefinition<T>(this.columns);
    }
}